module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2025-10-08 at 13.01.57_b2dbc33c.f4e30112.jpg";